module.exports = __webpack_public_path__ + "img/reference-mwmgold.5144a2eb.webp";